<template>
  <div>
    <link
      href="https://cdn.staticfile.org/quill/1.3.6/quill.core.css"
      rel="stylesheet"
    />
    <div class="se-m-b-20">
      <!-- 首页 > 技能考试 > 课程详情 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/user/index' }"
          >个人中心</el-breadcrumb-item
        >
        <el-breadcrumb-item
          >{{ type === "course" ? "课程" : "学习计划" }}详情</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div v-if="type === 'course'" class="se-video">
      <!-- <img
        src="../../assets/images/video.png"
        style="width: 100%; height: 100%"
      /> -->
      <img
        v-show="!isPlay"
        :src="
          courseDetails.coverUrl || require('../../assets/images/video.png')
        "
        style="width: 100%; height: 100%"
      />
      <div class="play" v-show="!isPlay">
        <img src="../../assets/images/play.png" @click="getPlay" />
      </div>
      <!-- @mousemove="controlerShowControl(true)"
        @mouseup="controlerShowControl(false)"
        @click='controlerShowControl(true)'> -->
      <div
        class="video-main"
        v-show="isPlay"
        ref="videoMain"
        @mousemove="controlerShowControl(true)"
        @mouseout="controlerShowControl(false)"
        @click="controlerShowControl(true)"
      >
        <video
					id="course"
          ref="course"
          :src="courseDetails.videoUrl"
          style="object-fit: fill"
        ></video>
        <transition name="fade">
          <div class="controls" v-show="controlerShow && token">
            <div class="back-play" @click="backPlay">
              <img src="../../assets/icons/back.png" alt="" />
            </div>
            <div class="play-btn" @click="controlPlay">
              <img
                :src="
                  require(`../../assets/icons/${
                    playing ? 'paused' : 'play'
                  }.png`)
                "
                alt=""
              />
            </div>
            <div class="time">{{ playTime }} / {{ totalTime }}</div>
            <div class="rates">
              <p>{{ playRates.find((s) => s.value === playRate).name }}</p>
              <div>
                <span
                  v-for="(item, index) of playRates"
                  :key="index"
                  :class="item.value === playRate ? 'active' : ''"
                  @click="changeRate(item.value)"
                  >{{ item.name }}</span
                >
              </div>
            </div>
            <div class="screen" @click="toggleFullscreen">
              <img src="../../assets/icons/screen.png" alt="" />
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-if="type === 'course'" class="se-msg">
      <div style="width: 70%">
        <div class="se-flex jcsb se-m-b-20">
          <div
            class="se-m-r-25 course-name"
            style="font-size: 18px; font-weight: 500"
          >
            {{ courseDetails.courseName }}
          </div>
          <div class="course-status">
            <img
              v-if="courseDetails.status == null || courseDetails.status == 1"
              :src="require('../../assets/status/1.png')"
            />
            <img
              v-if="courseDetails.status == 2"
              :src="require('../../assets/status/2.png')"
            />
            <img
              v-if="courseDetails.status == 3"
              :src="require('../../assets/status/3.png')"
            />
            <img
              v-if="courseDetails.status == 4"
              :src="require('../../assets/status/4.png')"
            />
            <img
              v-if="courseDetails.status == 5"
              :src="require('../../assets/status/5.png')"
            />
          </div>
        </div>
        <div class="se-flex jcsb" style="height: 22px">
          <div class="se-flex">
            <div class="se-flex aic se-m-r-40">
              <img
                src="../../assets/icons/time.png"
                style="width: 16px; height: 16px"
              />
              <div class="se-m-l-5 ft-14-666">{{ courseDetails.passTime }}</div>
            </div>

            <div class="se-flex aic se-m-r-40">
              <img
                src="../../assets/icons/cap.png"
                style="width: 18px; height: 16px"
              />
              <div class="se-m-l-5 ft-14-666">
                学习次数：{{ courseDetails.count }}次
              </div>
            </div>

            <div class="se-flex aic">
              <img
                src="../../assets/icons/user.png"
                style="width: 17px; height: 17px"
              />
              <div class="se-m-l-5 ft-14-666">
                {{
                  courseDetails.teacherName ? courseDetails.teacherName : "暂无"
                }}
              </div>
            </div>
          </div>
          <div class="se-rote">
            <span class="se-num">{{ avgStar }}</span
            >星
          </div>
        </div>
      </div>
      <div class="se-line"></div>
      <div class="se-flex" style="width: 30%">
        <div
          class="se-btn-1 se-m-r-30 cp"
          @click="addStudyPlan"
          v-if="joinStudy.length == 0"
        >
          加入我的课程
        </div>
        <!-- @click="getPlay" -->
        <div
          class="se-btn-2 cp"
          style="background-color: #ccc; border: none"
          v-else
        >
          已加入我的课程
        </div>
      </div>
    </div>
    <div v-if="type === 'study'" class="se-study">
      <img :src="planInfo.coverUrl" style="width: 450px; height: 250px" />
      <div class="se-m-l-30 study-plan" style="flex: 1">
        <div class="se-flex jcsb aic">
          <div class="ft-24-333 se-m-b-15 course-name">
            {{ planInfo.planName }}
          </div>
          <!-- <img src="../../assets/icons/status2.png" style="57px;height:24px;" /> -->
          <div class="course-status">
            <img :src="`(../../assets/status/${planInfo.status}.png)`" alt="" />
          </div>
        </div>
        <div class="se-flex ft-14-666 aic" style="white-space: nowrap">
          <div v-if="planInfo.planType === '1'">
            {{ planInfo.endCourseCount }}/{{ planInfo.totalCourseCount }} 课时
          </div>
          <div v-if="planInfo.planType === '2'" class="">线下</div>
          <div v-if="planInfo.planType === '2'" class="se-dot"></div>
          <div v-if="planInfo.planType === '2'">{{ planInfo.teacherName }}</div>
          <div class="se-dot"></div>
          <div>{{ planInfo.number }}人学习</div>
          <!-- <div class="se-dot"></div> -->
        </div>
        <div>{{ planInfo.planBeginTime }} - {{ planInfo.planEndTime }}</div>
        <div class="se-flex">
          <el-rate v-model="planInfo.star" disabled text-color="#ff9900">
          </el-rate>
          <div class="se-m-l-10 ft-14-666">{{ planInfo.star }}星</div>
        </div>
        <div v-if="planInfo.planType === '1'" class="se-m-b-15">
          <span class="ft-18-999">已学习</span>
          <!-- <span class="ft-18-red"
            >{{
              planInfo.totalCourseCount
                ? (planInfo.endCourseCount / planInfo.totalCourseCount).toFixed(
                    2
                  ) * 100
                : 0
            }}%</span
          > -->
          <span class="ft-18-red"
            >{{
              planInfo.finishedRate ? parseInt(planInfo.finishedRate * 100) : 0
            }}%</span
          >
        </div>
        <div v-if="planInfo.planType === '2'">
          {{ planInfo.isSign === 0 ? "未签到" : "已签到" }}
        </div>
        <div class="se-flex cp">
          <div
            v-if="planInfo.planType === '1'"
            class="se-btn-2 se-m-r-20"
            @click="beginStudy"
          >
            开始学习
          </div>
          <el-popover placement="bottom" trigger="click">
            <vue-qr
              :text="url"
              :margin="0"
              colorDark="#000"
              colorLight="#fff"
              :logoScale="0.5"
              :size="181"
            ></vue-qr>
            <div class="se-btn-1" slot="reference">手机查看</div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="se-flex se-m-t-20">
      <div class="se-main-left se-m-r-20 br-5">
        <el-tabs v-model="activeName" @tab-click="tabsChange">
          <el-tab-pane label="介绍" name="first">
            <div>
              <div class="ft-14-333-b se-p-t-20 se-p-b-20">
                {{ courseDetails.courseName }}
              </div>
              <div
                class="ft-14-333 ql-editor"
                v-html="courseDetails.courseSummary"
              ></div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="type === 'course'" label="课件" name="second">
            <el-empty
              v-if="swtList.length === 0"
              description="暂无课件"
            ></el-empty>
            <div class="se-list" v-loading="loading">
              <div
                class="se-item se-flex jcsb"
                v-for="(item, i) in swtList"
                :key="i"
                @click="lookFile(item.fileUrl)"
              >
                <div class="se-flex aic" style="flex: 1">
                  <img
                    src="../../assets/icons/file.png"
                    style="width: 31px; height: 26px"
                  />
                  <!-- <div class="ft-18-000 se-m-l-20">文档.docx</div> -->
                  <div class="ft-18-000 se-m-l-20 file-name">
                    {{ item.fileName }}
                  </div>
                </div>
                <!-- <div
                  class="se-flex upload-btn se-m-l-10"
                  @click="getDownLoad(item.fileUrl, item.fileName)"
                >
                  <img
                    src="../../assets/icons/xiazai.png"
                    style="width: 17px; height: 16px"
                  />
                  <div class="ft-14-red se-m-l-10">下载</div>
                </div> -->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="type === 'study' && planInfo.planType === '1'"
            label="目录"
            name="third"
          >
            <el-empty
              v-if="courseVos.length === 0"
              description="暂无目录"
            ></el-empty>
            <div class="catalogue-list">
              <div
                class="catalogue-Item se-flex jcsb se-p-t-25 se-p-b-25 se-bor-b cp"
                v-for="(v, i) in courseVos"
                :key="i"
                @click="goToCanStudy(v)"
              >
                <div class="se-flex aic">
                  <div class="ft-18-000 se-m-r-25 course-name">
                    {{ i + 1 }}、{{ v.courseName }}
                  </div>
                  <!-- <div class="ft-12-999-4">
                    ({{ planInfo.planBeginTime }} - {{ planInfo.planEndTime }})
                  </div> -->
                </div>
                <div
                  class="se-completed"
                  v-if="v.status === 2"
                  style="border-color: #ff9000; color: #ff9000"
                >
                  {{ v.studyRate * 100 }}%
                </div>
                <div
                  class="se-completed"
                  v-else
                  :style="{
                    borderColor:
                      v.status === 3 || v.status === 4
                        ? '#FF9000'
                        : v.status === 1
                        ? '#f0760a'
                        : v.status === 5
                        ? '#373737'
                        : '',
                    color:
                      v.status === 3 || v.status === 4
                        ? '#FF9000'
                        : v.status === 1
                        ? '#f0760a'
                        : v.status === 5
                        ? '#373737'
                        : '',
                  }"
                >
                  {{
                    v.status === 1
                      ? "待开始"
                      : v.status === 3
                      ? "待考试"
                      : v.status === 4
                      ? "待评价"
                      : v.status === 5
                      ? "已完成"
                      : "进行中"
                  }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="type === 'study' && planInfo.planType === '2'"
            label="签到"
            name="sixth"
          >
            <div v-if="planInfo.isSign === 0">
              <div class="ft-14-333-b se-p-t-20 se-p-b-20">未签到</div>
              <div class="se-m-t-10">请前往手机端企业微信签到</div>
            </div>
            <div v-else>已签到</div>
          </el-tab-pane>
          <el-tab-pane label="考试" name="fifth">
            <div class="se-test-list" v-if="numAndTotal.topicNum !== 0">
              <div
                class="se-text-item se-flex jcsb se-p-t-20 se-p-b-20 se-bor-b"
              >
                <div class="se-flex aic">
                  <img
                    src="../../assets/icons/onlineTest.png"
                    style="width: 50px; height: 47px"
                  />
                  <div class="se-m-l-15">
                    <div class="se-m-b-5 ft-18-000">
                      {{ type === "course" ? "课程" : "学习计划" }}在线考试
                    </div>
                    <div class="se-flex">
                      <div class="se-m-r-50 ft-14-666">
                        题目量：{{ numAndTotal.topicNum }}题
                      </div>
                      <div class="ft-14-666">
                        总分：{{ numAndTotal.topicTotal }}分
                      </div>
                    </div>
                  </div>
                </div>
                <el-button
                  v-if="numAndTotal.topicNum !== 0"
                  type="danger"
                  style="background-color: #e44352; max-height: 40px"
                  @click="isShowTest"
                  >{{
                    courseDetails.status === 4 ||
                    planInfo.status === 4 ||
                    courseDetails.status === 5 ||
                    planInfo.status === 5
                      ? "已考试"
                      : "开始考试"
                  }}</el-button
                >
              </div>
            </div>
            <el-empty v-else description="暂无考试"></el-empty>
          </el-tab-pane>
          <el-tab-pane :label="'评价（' + starTotal + '）'" name="fourth">
            <div class="se-eva-list se-m-t-20">
              <div class="se-flex jcsb aic">
                <div class="se-flex aic">
                  <div class="ft-36-yellow">{{ avgStar }}</div>
                  <div class="se-m-l-15">
                    <el-rate
                      v-model="avgStar"
                      disabled
                      void-icon-class="el-icon-star-on"
                      void-color="#ccc"
                    ></el-rate>
                    <div class="ft-12-999">共{{ starTotal }}条评论</div>
                  </div>
                </div>
                <el-button
                  type="danger"
                  style="background-color: #e44352"
                  @click="isShow"
                  >{{
                    courseDetails.status === 5 || planInfo.status === 5
                      ? "已评价"
                      : "我要评价"
                  }}</el-button
                >
              </div>
              <div
                class="se-eva-item"
                v-for="(item, i) in courseContentList"
                :key="i"
              >
                <evaluate-item :item="item"></evaluate-item>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="se-main-right">
        <div
          v-if="type === 'course' && courseDetails.teacherName"
          class="se-right-top br-5 se-m-b-20"
        >
          <div>
            <div class="se-flex aic">
              <el-avatar
                :size="70"
                :src="
                  teacherInfo.avatar
                    ? teacherInfo.avatar
                    : require('../../assets/images/logo2.png')
                "
              ></el-avatar>
              <div class="se-m-l-15">
                <div class="se-flex se-m-b-10 aic">
                  <div class="ft-18-333 se-m-r-15 teacher-name">
                    {{
                      teacherInfo.teacherName
                        ? teacherInfo.teacherName
                        : courseDetails.teacherName
                    }}
                  </div>
                  <img
                    v-if="teacherInfo.iconUrl || courseDetails.teacherName"
                    :src="
                      teacherInfo.iconUrl
                        ? teacherInfo.iconUrl
                        : require('../../assets/images/tags.png')
                    "
                    style="width: 90px; height: 30px; object-fit: cover"
                  />
                </div>
                <div class="ft-14-333">
                  {{ teacherInfo.companyName }}
                </div>
              </div>
            </div>

            <div
              v-if="type === 'course' && this.hasTeacher"
              class="se-flex jcsb se-m-t-30 se-p-l-10 se-p-r-10"
            >
              <div class="se-flex-v-c">
                <div class="ft-16-333-b se-m-b-5">{{ teacherInfo.star }}</div>
                <div class="ft-14-333">好评度</div>
              </div>
              <div class="se-bor"></div>
              <div class="se-flex-v-c">
                <div class="ft-16-333-b se-m-b-5">
                  {{ teacherInfo.courseNum }}
                </div>
                <div class="ft-14-333">课程数</div>
              </div>
              <div class="se-bor"></div>
              <div class="se-flex-v-c">
                <div class="ft-16-333-b se-m-b-5">{{ teacherInfo.num }}</div>
                <div class="ft-14-333">学习人次</div>
              </div>
            </div>
            <div
              v-if="type === 'course' && this.hasTeacher"
              class="teacher-tags"
            >
              <el-tag
                style="margin-right: 5px; margin-bottom: 10px"
                size="mini"
                type="danger"
                v-for="(v, i) in teacherLabels"
                :key="i"
                >{{ v }}</el-tag
              >
            </div>
            <div
              v-if="type === 'course' && this.hasTeacher"
              class="ft-14-666-b se-m-t-10 teacher-summary"
            >
              <el-tooltip
                class="item"
                effect="light"
                :content="teacherInfo.teacherSummary"
                placement="top"
              >
                <span>{{ teacherInfo.teacherSummary }}</span>
              </el-tooltip>
            </div>
          </div>
          <div v-if="type === 'course' && this.hasTeacher" class="se-p-t-20">
            <div class="ft-18-333 se-m-b-20 se-p-t-20 se-bor-t">联系方式</div>
            <div class="se-flex se-m-b-10 aic" v-if="teacherInfo.wechatUserId">
              <img
                src="../../assets/icons/wechat.png"
                style="width: 25px; height: 25px"
              />
              <div class="ft-14-333 se-m-l-15">
                {{ teacherInfo.wechatUserId }}（企业微信）
              </div>
            </div>
            <div class="se-flex aic">
              <img
                src="../../assets/icons/phone_yellow.png"
                style="width: 25px; height: 25px"
              />
              <div class="ft-14-333 se-m-l-15">
                {{ teacherInfo.phonenumber }}（手机号）
              </div>
            </div>
          </div>
        </div>
        <div class="se-right-bottom br-5">
          <div class="ft-18-333 se-m-b-20">其他课程</div>
          <div
            class="se-card br-5 se-bs-b se-m-b-20 se-p-b-20"
            v-for="(item, index) of otherCourseList"
            :key="index"
          >
            <course-item :item="item">
              <div class="se-go" @click="goToStudy(item)">去学习</div>
            </course-item>
            <!-- <div class="se-go">去学习</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 评价对话框 -->
    <el-dialog title="评价" :visible.sync="visible" width="28%">
      <user-evaluate
        :satrInfo="satrInfo"
        :joinType="joinType"
        :planId="planId"
        ref="evaluate"
        @getCourseContentList="getCourseContentList"
        @updateEva="updateEva"
      ></user-evaluate>
      <span slot="footer" class="se-flex jcc">
        <el-button @click="visible = false" style="width: 117px"
          >取 消</el-button
        >
        <el-button type="danger" style="width: 117px" @click="setEvaluate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 开始考试对话框 -->
    <el-dialog class="se-dialog" :visible.sync="testVisible" width="665px">
      <start-test
        :type="type"
        :examData="examData"
        @onClose="onClose"
        @updateExam="updateExam"
        :courseId="courseId"
        :planId="planId"
      ></start-test>
    </el-dialog>

    <el-dialog
      title="拍照存档"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="showCamera"
      width="680px"
    >
      <div class="camera">
        <!--canvas截取流-->
        <canvas ref="canvas" width="640" height="480"></canvas>
        <!--图片展示-->
        <video ref="video" width="640" height="480" autoplay></video>
        <!--确认-->
        <el-button type="primary" style="margin-top: 30px" @click="photograph"
          >拍照上传</el-button
        >
      </div>
    </el-dialog>

    <!-- 定时提醒对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="tipVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="30%"
    >
      <span>您是否还在观看？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isLook">是</el-button>
        <el-button @click="tipVisible = false">否</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import Qs from "qs";
import courseItem from "../components/courseItem.vue";
import evaluateItem from "./components/evaluateItem.vue";
import userEvaluate from "./components/userEvaluate.vue";
import startTest from "./components/startTest.vue";
import { path } from "@/utils/path.js";
// import flvjs from 'flv.js'

export default {
  components: {
    vueQr,
    courseItem,
    evaluateItem,
    userEvaluate,
    startTest,
  },

  data() {
    return {
      once: 0,
      times: 0,
      showCamera: false,
      token: this.$store.state.token,
      planInfo: {},
      courseVos: [],
      beginTime: "",
      examData: {},
      isPlay: false,
      activeName: "first",
      star: 2,
      visible: false,
      testVisible: false,
      studyStar: 5,
      type: "",
      remarkNum: 0,
      remarkStar: 0,
      joinStudy: [], //加入学习
      otherCourseList: [], //其他推荐课程
      swtList: [],
      courseContentList: [],
      courseDetails: {
        courseName: "",
        coverUrl: "",
      }, //课程详情
      courseFiles: [], //课件
      teacherInfo: {}, //讲师信息
      courseId: "",
      teacherId: "",
      numAndTotal: {
        topicNum: 0,
        topicTotal: 0,
      },
      avgStar: 0,
      starTotal: 0,
      satrInfo: {
        hasContent: true,
        hasStar: true,
        trainCourseEvaTmplLabels: [],
      },
      controlerShow: true,
      voiceProgressShow: true,
      playing: false,
      totalTime: "--",
      playTime: "--",
      fullScreenState: false,
      playRate: 1,
      playRates: [
        { name: "0.8×", value: 0.8 },
        { name: "1.0×", value: 1 },
        { name: "1.2×", value: 1.2 },
        // { name: "16×", value: 16 },
      ],
      joinType: this.$route.query.joinType,
      planId: "",
      rate: "",
      tipVisible: false,
      flag: true,
      playFlag: false,
      now: 0,
      isTimingUn20: null,
      isTimingUp20_1: null,
      isTimingUp20_2: 0,
      allTime: 0,
      isEnding: false,
      loading: false,
      canPlay: true,
      teacherLabels: [],
      hasTeacher: null,
			// flvPlayer: null
    };
  },

  computed: {
    url() {
      // 汉阳测试
      // return `${location.origin}/front-mobile/#/pages/study/planStudy?planId=${this.planId}&planType=${this.planInfo.planType}`;
      // 好快测试
      return `${path}/#/pages/study/planStudy?planId=${this.planId}&planType=${this.planInfo.planType}`;
    },
  },

  watch: {
    "$route.query.t"() {
      location.reload();
    },

    now(value) {
      if(this.allTime <= 600){
        this.showCamera = false;
        return
      }
      const course = this.$refs.course;
      if (this.allTime <= 1200&&this.allTime>=600) {
        if (this.isTimingUn20 === value && this.flag) {
          this.controlPlay();
          this.exitFullscreen();
          // this.isTip();  
          setTimeout(() => {
            course.pause();
          }, 10);
          this.showCamera = true;
          this.$nextTick(() => {
            this.callCamera();
          });
          // this.playing = true;
          // course.play();
        }
      } else {
        if (this.isTimingUp20_1 === value && this.flag) {
          this.controlPlay();
          this.exitFullscreen();
          // this.isTip();
          setTimeout(() => {
            course.pause();
          }, 10);
          this.$refs.course.pause();
          this.showCamera = true;
          this.$nextTick(() => {
            this.callCamera();
          });
          // this.playing = true;
          // course.play();
        }
         if (this.isTimingUp20_2 === value && this.flag) {
          this.controlPlay();
          this.exitFullscreen();
          // this.isTip();
          setTimeout(() => {
            course.pause();
          }, 10);
          this.$refs.course.pause();
          this.showCamera = true;
          this.$nextTick(() => {
            this.callCamera();
          });
          // this.playing = true;
          // course.play();
        }
      }
    },

    // rate(value) {
    //   if (value == 1 && this.flag) {
    //     this.controlPlay();
    //     this.exitFullscreen();
    //     this.isTip();
    //   } else if (value == 5 && this.flag) {
    //     this.controlPlay();
    //     this.exitFullscreen();
    //     this.isTip();
    //   } else if (value === 7 && this.flag) {
    //     this.controlPlay();
    //     this.exitFullscreen();
    //     this.isTip();
    //   } else if (value === 9 && this.flag) {
    //     this.controlPlay();
    //     this.exitFullscreen();
    //     this.isTip();
    //   }
    // },
  },

  beforeDestroy() {
    if (localStorage.getItem("token")) {
      if (this.playFlag) this.getPaused();
    }
  },

  destroyed() {
    window.removeEventListener("beforeunload", () => this.getPaused());
    // window.removeEventListener("beforeunload", (e) =>
    //   this.beforeunloadHandler(e)
    // );
  },

  created() {
    console.log(location.origin, "location.origin");

    this.joinType = parseInt(this.$route.query.joinType || 1);
    this.courseId = this.$route.query.courseId;
    this.teacherId = this.$route.query.teacherId;
    this.planId = this.$route.query.planId || "";
    this.type = this.$route.query.type;
    this.getOtherCourseList(); //获取其他课程推荐
    this.getNumAndTotal(); //考题量及总分
    if (this.type === "course") {
      this.getBrowse(); //浏览
      this.getCourseInfo();
      this.getCourseContentList(); //获取课程评价列表
      this.getisJoinStudy(); //是否加入学习
      this.getSwtList(); //课件
      // window.addEventListener("beforeunload", () => this.getPaused());
    } else {
      this.getPlanInfo(); // 计划详情
      this.getPlanContent(); // 计划评价
    }
  },

  mounted() {
    // window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },

  methods: {
    // async beforeunloadHandler() {
    //   await this.getPaused();
    // },
    // 弹窗提醒
    isTip() {
      this.tipVisible = true;
    },

    isLook() {
      this.tipVisible = false;
      this.playing = true;
      const course = this.$refs.course;
      course.play();
    },
    controlerShowControl(show) {
      if (show) {
        setTimeout(() => {
          if (this.playState) {
            this.controlerShow = false;
            this.voiceProgressShow = false;
          }
        }, 3000);
      }

      this.controlerShow = show;
      // console.log(this.controlerShow);
    },

    beginStudy() {
      const { endCourseCount, totalCourseCount } = this.planInfo;
      const { courseVos } = this;
      // console.log(courseVos, "courseVos");
      // console.log(totalCourseCount, "totalCourseCount");
      // console.log(endCourseCount, "endCourseCount");
      if (!totalCourseCount) {
        this.$message.info("该计划没有课程");
        return;
      } else {
        this.goToStudy(courseVos[0]);
      }
      // if ((endCourseCount / totalCourseCount).toFixed(2) * 100 === 100) {
      //   this.goToStudy(courseVos[0]);
      //   return;
      // }
      // if (courseVos.every((v) => v.status === 1)) {
      //   this.goToStudy(courseVos[0]);
      //   return;
      // }
      // if (courseVos.some((v) => v.status === 1)) {
      //   const course = courseVos.find((s) => s.status === 1);
      //   this.goToStudy(course);
      //   return;
      // }
      // const course = courseVos.find((s) => s.status === 2);
      // if (!course) {
      //   this.$message.info("没找到课程");
      //   return;
      // }
    },
    async getPlanContent() {
      const res = await this.$http.get(
        `server/portal/personCenter/getCourseContent/${this.planId}`
      );
      this.courseContentList = res.data.styMyPlans;
      this.remarkNum = res.data.commentCount;
      this.avgStar = res.data.avgStar;
      this.starTotal = res.data.total;
    },

    async getPlanInfo() {
      const res = await this.$http.get(
        `server/portal/personCenter/getStudyPlanById/${this.planId}`
      );
      this.planInfo = res.data;
      this.courseVos = res.data.courseVos;
      this.courseDetails = {
        courseName: res.data.planName,
        courseSummary: res.data.planDetail,
      };
    },
    setEvaluate() {
      this.$refs.evaluate.setEvaluate(
        this.type === "course" ? this.courseId : this.planId,
        this.courseDetails.teacherId,
        this.type
      );
    },
    // 标签页变化回调
    tabsChange(e) {
      // console.log(e);
    },

    // 展示评价对话框
    async isShow() {
      // console.log(this.courseDetails, "this.courseDetails");
      // console.log(this.planInfo, "planInfo");
      // if (!this.token) {
      //   this.$message.error("请登录查看");
      //   return;
      // }
      if ([null, 1, 2].includes(this.courseDetails.status)) {
        return this.$message.info("课程还未学完");
      }
      if (this.courseDetails.status === 3) {
        return this.$message.info("课程还未考试");
      }
      if (this.courseDetails.status === 5) {
        return this.$message.info("课程已经评价");
      }
      // console.log(this.planInfo, "planInfo");
      if (this.planInfo.planType === "2") {
        if (this.planInfo.status === 1) {
          return this.$message.info("计划还未签到");
        }
        if (this.planInfo.status === 2 || this.planInfo.status === 3) {
          return this.$message.info("计划还未考试");
        }
        if (this.planInfo.status === 5) {
          return this.$message.info("计划已经评价");
        }
      } else {
        if (this.planInfo.status === 1 || this.planInfo.status === 2)
          return this.$message.info("计划还未学完");
        if (this.planInfo.status === 3)
          return this.$message.info("计划还未考试");
        if (this.planInfo.status === 5)
          return this.$message.info("计划已经评价");
      }

      const {
        data: {
          hasContent,
          hasStar,
          trainCourseEvaTmplLabels,
          trainPlanEvaTmplLabels,
        },
      } = await this.$http.get(
        this.type === "course"
          ? `server/portal/home/getTrainCourseEvaTmpl/${this.courseId}`
          : `server/portal/personCenter/getPlanTemplate/${this.planId}`
      );

      this.satrInfo = {
        hasContent,
        hasStar,
        trainCourseEvaTmplLabels:
          this.type === "course"
            ? trainCourseEvaTmplLabels
            : trainPlanEvaTmplLabels,
      };
      this.visible = true;
    },

    // 展示开始考试
    isShowTest() {
      this.getExamList();
    },

    // close
    onClose() {
      this.testVisible = false;
    },

    //浏览
    getBrowse() {
      this.$http.post(`server/portal/home/addClickRecord/${this.courseId}`);
    },

    // 去课程详情
    getCourseInfo() {
      // this.type = "course";
      // this.activeName = "first";
      let data = {
        courseId: "123",
      };
      this.$http
        .get("server/portal/home/getcourseDetails/" + this.courseId, {
          planId: this.planId,
        })
        .then((res) => {
          this.courseDetails = res.data;
					// var suffix =  this.courseDetails.videoUrl.substring(this.courseDetails.videoUrl.lastIndexOf(".") + 1);
					// if(suffix === 'flv') {
					// 		this.$nextTick(() => {
					// 			const videoElement = document.getElementById('course')
					// 			this.flvPlayer = flvjs.createPlayer({
					// 				type: 'flv',
					// 				isLive: true,
					// 				url: this.courseDetails.videoUrl,
					// 				fixAudioTimestampGap: false
					// 			})
					// 			this.flvPlayer.attachMediaElement(videoElement)
					// 			this.flvPlayer.load()
					// 		})
					// }
          this.hasTeacher = !!res.data.teacherId;
          if (res.data.teacherId) {
            this.getTeacherInfo();
          }
        });
    },

    changeRate(value) {
      this.playRate = value;
      const course = this.$refs.course;
      course.playbackRate = value;
    },

    controlPlay() {
			// this.$refs.course.pause()
      const course = this.$refs.course;
      if (!this.canPlay)
        return this.$message.error("调取摄像头失败,无法继续观看");
      this.playing ? course.pause() : course.play();
      this.playing = !this.playing;
    },

    async getPlay() {
      if (!this.canPlay)
        return this.$message.error("调取摄像头失败,无法继续观看");
      const token = localStorage.getItem("token");
      // if (!token) {
      //   this.$message.error("请登录查看");
      //   return;
      // }

      if (this.joinStudy.length === 0) {
        this.$message.info("请先加入我的课程");
        return;
      }

      this.playFlag = true;
      const course = this.$refs.course;
      this.isPlay = true;
      this.playing = true;
      if (this.isEnding) {
        this.playing = false;
        // console.log(this.isEnding, "is");
        this.controlPlay();
        this.isEnding = false;
        return;
      }
      const {
        data: { videoPalyProgress },
      } = await this.$http.get(
        `server/portal/getvideoDisplay/${this.courseId}`,
        { planId: this.planId }
      );
      // console.log(videoPalyProgress)

      // if (videoPalyProgress) {
      //   this.$http
      //     .get("api/styrecord/list", {
      //       courseId: this.courseId,
      //       planId: this.planId,
      //     })
      //     .then((res) => {
      //       console.log(res, "res");
      //     });
      // }

      course.currentTime = videoPalyProgress;
      this.getCourseInfo();

      // 可播放时触发
      course.addEventListener("canplay", (e) => this.getCanplay(e), false);

      // 暂停
      course.addEventListener("pause", (e) => this.getPaused(e), false);

      // 结束
      course.addEventListener("ended", (e) => this.getPaused(e, true), false);

      // 播放时间变化
      course.addEventListener(
        "timeupdate",
        (e) => this.getTimeupdate(e),
        false
      );
    },

    getTimeupdate(e) {
      const course = this.$refs.course;
      this.playTime = this.formatSeconds(course.currentTime);
      // console.log(course.currentTime, "course.currentTime");

      const now = parseInt(course.currentTime);
      const total = parseInt(course.duration);
      this.now = now;
      this.allTime = total;
      console.log('this.allTime',this.allTime);
      if (total <= 1200) {
        this.isTimingUn20 = parseInt(total / 2);
        // console.log(this.isTimingUn20, 'timing')
      } else {
        this.isTimingUp20_1 = 600;
        this.isTimingUp20_2 = total - 1200;
        // console.log(this.isTimingUp20_2, 'isTimingUp20_2')
      }
      // this.rate = Number((now / total).toFixed(1)) * 10
      // this.rate = Number((now / total).toFixed(1)) * 10;

      // 开启摄像头。功能太鸡肋
      // const now = parseInt(course.currentTime);
      // const total = parseInt(course.duration);
      // if (now / total > 0.1) {
      //   this.once++;
      //   if (this.once === 1) {
      //     this.showCamera = true;
      //     this.$nextTick(() => {
      //       this.callCamera();
      //     });
      //   }
      // }
    },

    callCamera() {
      // 调用电脑摄像头API
      if (!navigator.mediaDevices) {
        this.$message.info("摄像头开启失败，请检查摄像头是否可用！");
        return;
      }
      this.$refs.course.pause();
      navigator.mediaDevices
        .getUserMedia({
          video: true,
        })
        .then((success) => {
          this.showCamera = true;
          // this.$refs.course.pause();
          // 摄像头开启成功
          this.$refs["video"].srcObject = success;
          // 实时拍照效果
          this.$refs["video"].play();
        })
        .catch((error) => {
          this.showCamera = false;
          console.error("摄像头开启失败，请检查摄像头是否可用！");
          // this.$message.info("摄像头开启失败，请检查摄像头是否可用！");
          this.$notify({
            title: "警告",
            message: "摄像头开启失败，请检查摄像头是否可用！否则无法考试",
            type: "warning",
            duration: 3000,
          });
          this.canPlay = false;
          // const course = this.$refs.course;
          // course.pause();
          this.$refs.course.pause();
        });
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },

    // 拍照
    async photograph() {
      let ctx = this.$refs["canvas"].getContext("2d");
      // 把当前视频帧内容渲染到canvas上
      ctx.drawImage(this.$refs["video"], 0, 0, 640, 480);
      // 转base64格式、图片格式转换、图片质量压缩---支持两种格式image/jpeg+image/png
      let imgBase64 = this.$refs["canvas"].toDataURL("image/jpeg", 0.7);
      // console.log(imgBase64);
      // console.log(this.base64toFile(imgBase64));
      if (imgBase64) this.uploadRecord(this.base64toFile(imgBase64));
    },

    async uploadRecord(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await this.$http.post("server/common/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // console.log(res.url);
      this.addRecord(res.url);
    },

    async addRecord(pictureUrl) {
      const data = {
        courseId: this.courseId,
        courseName: this.courseDetails.courseName,
        planId: this.planId,
        pictureUrl,
      };
      if (this.planId === "") {
        delete data.planId;
      }
      await this.$http.post("server/portal/insertStyStudyRecord", data);
      this.$message.success("上传记录成功");
      this.showCamera = false;
      this.playing = true;
      const course = this.$refs.course;
      course.play();
      this.closeCamera();
    },

    // 关闭摄像头
    closeCamera() {
      if (!this.$refs["video"].srcObject) return;
      let stream = this.$refs["video"].srcObject;
      let tracks = stream.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
      this.$refs["video"].srcObject = null;
    },

    requestFullscreen(ele) {
      // 全屏兼容代码
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
      this.fullScreenState = true;
    },

    toggleFullscreen() {
      // 切换全屏
      //this.fullScreenState = !this.fullScreenState;
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.requestFullscreen(this.$refs.videoMain);
      }
    },

    isFullScreen() {
      return (
        document.isFullScreen ||
        document.mozIsFullScreen ||
        document.webkitIsFullScreen
      );
    },

    // 取消全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      this.fullScreenState = false;
    },

    formatSeconds(value, type) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600) || "00";
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60) || "00";
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60) || "00";

      const res = `${h}:${m}:${s}`;
      return res;
    },

    backPlay() {
      if (!this.canPlay)
        return this.$message.error("调取摄像头失败,无法继续观看");
      this.flag = false;
      const course = this.$refs.course;
      const now = parseInt(course.currentTime);
      course.currentTime = now - 5 > 0 ? now - 5 : 0;
      this.playing = true;
      // course.pause();
      setTimeout(() => {
        this.flag = true;
      }, 1000);
    },

    getCanplay(e) {
      const course = this.$refs.course;
      this.totalTime = this.formatSeconds(course.duration, "total");
      // console.log(course.duration, "course.duration");
      // console.log(this.totalTime, "this.totalTime");
      course.play();
    },

    async getPaused(e, ended) {
      this.isEnding = true;
      const course = this.$refs.course;
			course.pause()
      this.playing = false;
      await this.$http.put("server/portal/updateVideoDisplay", {
        courseId: this.courseId,
        studyRate: ended
          ? 1
          : (course.currentTime / course.duration).toFixed(2),
        teacherId: this.courseDetails.teacherId,
        videoPalyProgress: parseInt(course.currentTime),
        planId: this.planId,
      });
      this.getCourseInfo();
    },

    //是否加入学习计划
    getisJoinStudy() {
      this.$http
        .get(
          `server/portal/home/getMyPlan/${this.courseId}?planId=${this.planId}`
        )
        .then((res) => {
          this.joinStudy = res.data;
        });
    },

    //获取考试题目
    getExamList() {
      // if (!this.token) {
      //   this.$message.error("请登录查看");
      //   return;
      // }
      if (this.planInfo.planType === "2") {
        if (this.planInfo.status === 1) {
          return this.$message.info("该计划未签到");
        }
      } else {
        if (this.planInfo.status === 1 || this.planInfo.status === 2) {
          return this.$message.info("该计划的课程还未学完");
        }
      }
      if (this.planInfo.status === 4 || this.planInfo.status === 5) {
        return this.$message.info("该计划已考试");
      }

      this.$http
        .get(
          this.type === "course"
            ? `server/portal/getExam/${this.courseId}`
            : `server/portal/personCenter/getPlanExam/${this.planId}`,
          this.type === "course" ? { planId: this.planId } : {}
        )
        .then((res) => {
          if (res.status === 200) {
            this.examData = res.data;
            this.testVisible = true;
          } else {
            this.$message.info(res.msg);
          }
        });
    },
    goToCanStudy(item) {
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
          t: new Date().getTime(),
          planId: this.$route.query.planId,
        },
      });
    },
    goToStudy(item) {
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
          planId: this.$route.query.planId,
          t: new Date().getTime(),
        },
      });
    },
    //其他课程推荐
    getOtherCourseList() {
      this.$http
        .get(
          "server/portal/home/getRecommendCourse/" +
            (this.courseId || this.planId)
        )
        .then((res) => {
          // console.log(123, res);
          this.otherCourseList = res.data;
        });
    },
    //加入学习计划
    addStudyPlan() {
      let token = localStorage.getItem("token");
      // if (!token) {
      //   this.$message.error("请登录后加入");
      //   return;
      // }
      let data = {
        courseId: this.courseId,
        teacherId: this.teacherId,
      };
      this.$http
        .post("server/portal/addMyPlan", data, {
          headers: {
            Authorization: "Bearer " + token,
            // "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.getisJoinStudy();
        });
    },

    //评价课程
    evaluate() {
      let data = {};
      this.$http
        .post("/server/portal/addEvaluate", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "123",
          },
        })
        .then((res) => {
          this.courseContentList = res.rows;
        });
    },

    //获取课程评价
    getCourseContentList() {
      if (this.type === "study") {
        this.getPlanContent();
        return;
      }
      this.$http
        .get(
          `server/portal/home/getCourseContent/${this.courseId}?planId=${this.planId}`
        )
        .then((res) => {
          this.courseContentList = res.data.styMyCourses;
          this.remarkNum = res.data.commentCount;
          this.avgStar = res.data.avgStar;
          this.starTotal = res.data.total;
        });
    },

    downLoad(file, name) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = file;
      // console.log(name);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.loading = false;
    },

    getDownLoad(url, fileName) {
      this.loading = true;
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const newUrl = window.URL.createObjectURL(x.response);
        // console.log("newUrl", newUrl);
        this.downLoad(newUrl, fileName);
      };
      x.send();
    },

    //获取课件
    getSwtList() {
      // let courseId = 1;
      this.$http
        .get("server/portal/home/getSwtExam/" + this.courseId)
        .then((res) => {
          this.swtList = res.data;
        });
    },

    // 预览
    lookFile(url) {
      const typeList = ["ppt", "pptx", "xlsx", "xls", "doc", "docx"];
      const arr = url.split(".");
      const type = arr[arr.length - 1];
      if (typeList.includes(type)) {
        open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
      } else {
        open(url);
      }
    },

    //获取讲师信息
    getTeacherInfo() {
      this.$http
        .get("/server/portal/home/getCourseTeacher/" + this.teacherId)
        .then((res) => {
          this.teacherInfo = res.data;
          if (res.data.teacherLabels && res.data.teacherLabels.length) {
            this.teacherLabels = Array.from(new Set(res.data.teacherLabels))
              .filter(Boolean)
              .slice(0, 8);
          }
        });
    },

    //获取考试题目量及总分
    getNumAndTotal() {
      this.$http
        .get(
          "/server/portal/home/getexamNumAndStar/" +
            (this.courseId || this.planId)
        )
        .then((res) => {
          this.numAndTotal = res.data;
        });
    },

    // 评价后刷新数据
    updateEva() {
      if (this.type === "course") {
        this.getCourseInfo();
      } else {
        this.getPlanInfo();
      }
      this.visible = false;
    },

    // 考试后刷新数据
    updateExam() {
      if (this.type === "course") {
        this.getCourseInfo();
      } else {
        this.getPlanInfo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.aic {
  cursor: pointer;
}

.se-video {
  width: 100%;
  // height: 676px;
  height: 60vh;
  position: relative;
  .play {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 80px;
      height: 80px;
      cursor: pointer;
    }
  }
  .video-main {
    position: relative;
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
    }
    .controls {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      background: rgba(0, 0, 0, 0.6);
      padding: 0 30px;
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 16px;
      .back-play {
        margin-right: 30px;
        width: 25px;
        height: 25px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .play-btn {
        width: 25px;
        height: 25px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .time {
        margin-left: 30px;
        flex: 1;
      }
      .rates {
        width: 100px;
        height: 50px;
        margin-right: 30px;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        div {
          position: absolute;
          top: -150px;
          left: 0;
          width: 100px;
          height: 150px;
          display: none;
          flex-direction: column;
          background: rgba(0, 0, 0, 0.6);
          span {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .active {
            color: #e44352;
          }
        }
        &:hover {
          div {
            display: flex;
          }
        }
      }
      .screen {
        width: 25px;
        height: 25px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.camera {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
  }
}

.se-msg {
  padding: 30px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-radius: 0 0 10px 10px;
}

.se-line {
  width: 1px;
  height: 68px;
  border-left: 1px solid rgba(216, 216, 216, 0.36);
  margin: 0 30px;
}

.se-rote {
  transform: translateY(-15px);
  color: #f9ae4e;
}

.se-num {
  font-size: 28px;
  color: #f9ae4e;
}

.se-btn-1,
.se-btn-2 {
  width: 150px;
  height: 47px;
  line-height: 47px;
  text-align: center;
  border: 1px solid #e44352;
  border-radius: 5px;
}

.se-btn-1 {
  color: #e44352;
}

.se-btn-2 {
  color: #fff;
  background-color: #e44352;
}

.se-main-left {
  flex: 1;
  padding: 20px 30px;
  background-color: #fff;
}

.se-main-right {
  width: 340px;
}

.se-right-top {
  background-color: #fff;
  padding: 20px;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: #f2f2f2;
}

/deep/ .el-tabs__item.is-active {
  color: #e44352;
}

/deep/ .el-tabs__active-bar {
  background-color: #e44352;
}

/deep/ .el-tabs__item:hover {
  color: #e44352;
}

.se-bor {
  width: 1px;
  height: 34px;
  border-left: 1px solid #f1f1f1;
}

.se-right-bottom {
  width: 100%;
  background-color: #fff;
  padding: 25px;
}

.se-card {
  width: 290px;
}

.se-go {
  width: 260px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
  font-size: 14px;
  font-weight: bold;
  color: #e44352;
  border: 1px solid #e44352;
  border-radius: 5px;
  margin: 0 auto;
}

.se-list {
  transform: translateY(-10px);
}

.se-item {
  border-bottom: 1px solid #f1f1f1;
  padding: 20px 0;
}

.se-btn-start {
  width: 120px;
  height: 47px;
  line-height: 47px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  background-color: #e44352;
}

/deep/ .se-dialog .el-dialog__header {
  padding: 0;
}

/deep/ .se-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .se-dialog .el-dialog {
  border-radius: 11px 11px 0 0;
}

.se-study {
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
  display: flex;
}

.se-dot {
  width: 4px;
  height: 4px;
  background-color: #666;
  border-radius: 50%;
  margin: 0 15px;
}

.se-completed {
  width: 57px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background-color: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  border: 1px solid #000;
}

/* controller淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.course-status {
  width: 60px;
  img {
    width: 100%;
    object-fit: cover;
  }
}

.teacher-name {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.study-plan {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.upload-btn {
  min-width: 55px;
}

.file-name {
  // white-space: nowrap;
}

.teacher-summary {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.course-name {
  width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teacher-tags {
  margin-top: 20px;
}
</style>

<style>
video::-webkit-media-controls {
  display: none !important;
}
</style>
